import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  GetCellsByNamesQueryDto,
  SmsAggregator,
} from 'src/app/core/api/models';
import { SmartSmsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
    selector: 'app-cells-list',
    templateUrl: './cells-list.component.html',
    standalone: false
})
export class CellsListComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  names: string;
  result: Array<GetCellsByNamesQueryDto>;
  parsedNames: string[];
  namesPlaceHolder: '[UN5032XB1,UT7478XB3,UE5323XA1,UE1119XA1,UT2272XB3]';

  //#endregion

  constructor(
    protected currentService: SmartSmsService,
    private dialogRef: MatDialogRef<CellsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      names: new FormControl('', Validators.required),
    });
  }

  //#region Api

  getCellsList() {
    this.unSubs();
    this.loading = true;
    this.currentService
      .smartSmsGetCellsByNames({
        body: {
          mobileOperators: [SmsAggregator.Irancell],
          names: this.parsedNames,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.result = result?.data;
        this.unSubs();
      });
  }

  //#endregion

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  onSubmit() {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;

      this.parsedNames = this.names
        .replace(/\[|\]/g, '')
        .split(',')
        .map((item) => item.trim());

      this.getCellsList();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }
}
